import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enLanding from './locales/en/landing.json';
import enDashboard from './locales/en/dashboard.json';
import enExpenses from './locales/en/expenses.json';
import enGoals from './locales/en/goals.json';
import enChecklist from './locales/en/checklist.json';
import enSettings from './locales/en/settings.json';
import enAdmin from './locales/en/admin.json';
import enChat from './locales/en/chat.json';
import enSubscription from './locales/en/subscription.json';

import zhCommon from './locales/zh/common.json';
import zhAuth from './locales/zh/auth.json';
import zhLanding from './locales/zh/landing.json';
import zhDashboard from './locales/zh/dashboard.json';
import zhExpenses from './locales/zh/expenses.json';
import zhGoals from './locales/zh/goals.json';
import zhChecklist from './locales/zh/checklist.json';
import zhSettings from './locales/zh/settings.json';
import zhAdmin from './locales/zh/admin.json';
import zhChat from './locales/zh/chat.json';
import zhSubscription from './locales/zh/subscription.json';

import viCommon from './locales/vi/common.json';
import viAuth from './locales/vi/auth.json';
import viLanding from './locales/vi/landing.json';
import viDashboard from './locales/vi/dashboard.json';
import viExpenses from './locales/vi/expenses.json';
import viGoals from './locales/vi/goals.json';
import viChecklist from './locales/vi/checklist.json';
import viSettings from './locales/vi/settings.json';
import viAdmin from './locales/vi/admin.json';
import viChat from './locales/vi/chat.json';
import viSubscription from './locales/vi/subscription.json';

const NAMESPACES = ['common', 'auth', 'landing', 'dashboard', 'expenses', 'goals', 'checklist', 'settings', 'admin', 'chat', 'subscription'];
const STORAGE_KEY = 'zlux-language';

const resources = {
  en: { common: enCommon, auth: enAuth, landing: enLanding, dashboard: enDashboard, expenses: enExpenses, goals: enGoals, checklist: enChecklist, settings: enSettings, admin: enAdmin, chat: enChat, subscription: enSubscription },
  zh: { common: zhCommon, auth: zhAuth, landing: zhLanding, dashboard: zhDashboard, expenses: zhExpenses, goals: zhGoals, checklist: zhChecklist, settings: zhSettings, admin: zhAdmin, chat: zhChat, subscription: zhSubscription },
  vi: { common: viCommon, auth: viAuth, landing: viLanding, dashboard: viDashboard, expenses: viExpenses, goals: viGoals, checklist: viChecklist, settings: viSettings, admin: viAdmin, chat: viChat, subscription: viSubscription },
};

const storedLanguage = typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : null;

i18n.use(initReactI18next).init({
  resources,
  lng: storedLanguage || 'en',
  fallbackLng: 'en',
  ns: NAMESPACES,
  defaultNS: 'common',
  interpolation: { escapeValue: false },
});

i18n.on('languageChanged', (lng) => {
  if (typeof window !== 'undefined') window.localStorage.setItem(STORAGE_KEY, lng);
});

export default i18n;
